import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet'
import { checkIcon, sampleIntro3 } from '../../resources/images'
import * as UIActions from '../../actions/uiAction';
import * as ProductActions from '../../actions/productAction';

class Pricing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedPlan: null,
            selectedPeriod: null,
            sampleData: {
                qBank: [
                    {
                        period: '3 Months',
                        price: 99
                    },
                    {
                        period: '6 Months',
                        price: 149
                    },
                    {
                        period: '12 Months',
                        price: 199
                    },
                    {
                        period: '18 Months',
                        price: 229
                    },
                    {
                        period: '24 Months',
                        price: 299
                    }
                ],
                qBankPlus: [
                    {
                        period: '3 Months',
                        price: 299
                    },
                    {
                        period: '6 Months',
                        price: 349
                    },
                    {
                        period: '12 Months',
                        price: 499
                    },
                    {
                        period: '18 Months',
                        price: 529
                    },
                    {
                        period: '24 Months',
                        price: 599
                    }
                ]
            }
        }
    }

    onSelectPlan = (selectedPlan) => {
        this.setState({
            selectedPlan
        })
    }

    onSelectPeriod = (selectedPeriod) => {
        this.setState({
            selectedPeriod
        })
    }

    onChangePlan = () => {
        this.setState({
            selectedPlan: null,
            selectedPeriod: null
        })
    }

    addCart = () => {
        const { selectedPeriod, selectedPlan, sampleData } = this.state
        const allowAddCart = selectedPeriod !== null && selectedPlan

        if (allowAddCart) {
            let item = {
                planName: selectedPlan,
                period: '',
                price: ''
            }

            if (selectedPlan === 'QBank') {
                item.period = sampleData.qBank[selectedPeriod].period
                item.price = sampleData.qBank[selectedPeriod].price
            } else {
                item.period = sampleData.qBankPlus[selectedPeriod].period
                item.price = sampleData.qBankPlus[selectedPeriod].price
            }

            this.props.addProductList(item)
            this.props.showSuccess('Add cart successfully')
            this.props.history.push('/cart')
        }
    }

    render() {
        const { selectedPlan, selectedPeriod, sampleData } = this.state
        const planOptions = selectedPlan === "QBank" ? sampleData.qBank : sampleData.qBankPlus
        return (
            <Fragment>
                <Helmet>
                    <title>QBank Landing Page</title>
                    <meta name="description" content="QBank landing allow user to know more about QBank Company background and also QBank products" />
                </Helmet>
                <div className="pricingPage">
                    {!selectedPlan ?
                        <Fragment>
                            <div className="titleCont">
                                <div className="fDisplay">CHOOSE YOUR QBANK OPTION</div>
                            </div>
                            <div className="qbTable">
                                <div className="qbRow">
                                    <div className="labelCont">
                                        <div className="fLabel header">Features</div>
                                    </div>
                                    <div className="productCont">
                                        <div className="qbCard">
                                            <div className="fTitle">QBank</div>
                                            <div className="fCaption">From $99</div>
                                            <div className="qbBtn" onClick={() => this.onSelectPlan('QBank')}>SELECT</div>
                                        </div>
                                    </div>
                                    <div className="productCont">
                                        <div className="qbCard">
                                            <div className="fTitle">QBank Integrated Plan</div>
                                            <div className="fCaption">From $99</div>
                                            <div className="qbBtn" onClick={() => this.onSelectPlan('QBank Integrated Plan')}>SELECT</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="qbRow">
                                    <div className="labelCont">
                                        <div className="fLabel">Over 3,300+ exam-like questions</div>
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                </div>
                                <div className="qbRow">
                                    <div className="labelCont">
                                        <div className="fLabel">3D BioDigital images and animations</div>
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                </div>
                                <div className="qbRow">
                                    <div className="labelCont">
                                        <div className="fLabel">150 question diagnostic exam</div>
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                </div>
                                <div className="qbRow">
                                    <div className="labelCont">
                                        <div className="fLabel">2 full-length simulated exams</div>
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                </div>
                                <div className="qbRow">
                                    <div className="labelCont">
                                        <div className="fLabel">26 Mastery Assessments with an additional 488 questions</div>
                                    </div>
                                    <div className="productCont" />
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                </div>
                                <div className="qbRow">
                                    <div className="labelCont">
                                        <div className="fLabel">70 hours of online, interactive videos with over 490 questions</div>
                                    </div>
                                    <div className="productCont" />
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                </div>
                                <div className="qbRow">
                                    <div className="labelCont">
                                        <div className="fLabel header">Both Included</div>
                                    </div>
                                    <div className="productCont" />
                                    <div className="productCont" />
                                </div>
                                <div className="qbRow">
                                    <div className="labelCont">
                                        <div className="fLabel">Full explanations and reKap summaries for all questions</div>
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                </div>
                                <div className="qbRow">
                                    <div className="labelCont">
                                        <div className="fLabel">Streamlined user experience with progress reports</div>
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                </div>
                                <div className="qbRow">
                                    <div className="labelCont">
                                        <div className="fLabel">Interface that replicates the actual Step 1</div>
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                </div>
                                <div className="qbRow">
                                    <div className="labelCont">
                                        <div className="fLabel">Mobile-friendly and available in the Kaplan app</div>
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                </div>
                                <div className="qbRow">
                                    <div className="labelCont">
                                        <div className="fLabel">Simple test creation and test-like interface</div>
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                    <div className="productCont">
                                        <img src={checkIcon} alt="Check Icon" className="qbIcon" />
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                        : <Fragment>
                            <div className="titleCont animateList">
                                <div className="fDisplay animated fadeInUp">LET'S PERSONALIZE YOUR PREP.</div>
                                <div className="fCaption animated fadeInUp">selected plan:</div>
                                <div className="btnCont animated fadeInUp">
                                    <span>{selectedPlan}</span>
                                    <div className="overlayCont" onClick={() => this.onChangePlan()}>EDIT</div>
                                </div>
                            </div>
                            <div className="planCont animateList">
                                {planOptions && planOptions.map((l, idx) =>
                                    <div key={idx} className={selectedPeriod === idx ? "itemCont animated fadeInUp active" : "itemCont animated fadeInUp"} onClick={() => this.onSelectPeriod(idx)}>
                                        <div className="fBody label">{l.period}</div>
                                        <div className="fBody">${l.price}</div>
                                    </div>
                                )}
                            </div>
                            <div className="actionCont">
                                <div className={selectedPeriod !== null ? "qbBtn animated fadeInUp valid" : "qbBtn animated fadeInUp"} onClick={() => this.addCart()}>ADD TO CART</div>
                            </div>
                        </Fragment>
                    }
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = ({ }) => ({
});

const mapDispatchToProps = (dispatch) => ({
    showSuccess: (msg) => dispatch(UIActions.showSuccess(msg)),
    addProductList: (item) => dispatch(ProductActions.addProductList(item))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Pricing));


// WEBPACK FOOTER //
// ./src/Components/pricing/Pricing.js